import { useEffect } from 'react';
import BaseColors from '@/atoms/colors/Base';
import CompleteOnboardingCard from '@/organisms/cards/CompleteOnboarding/CompleteOnboardingCard';
import Dashboard from '@/organisms/dashboards/Dashboard';
import Navigation from '@/organisms/dashboards/Navigation';
import { useDesignsContext } from '@/shared/providers/DesignsProvider';
import Box from '@/components/Box';
import ContextBarContainer from '@/components/ContextBarContainer';
import useContextStore from '@/components/ContextBarContainer/useContextStore';
import DashboardSkeleton from './DashboardSkeleton';

const registry = {
  DASHBOARD: Navigation,
};

const DashboardLayout = () => {
  const { isLoading } = useDesignsContext();
  const { bar, setBar } = useContextStore();
  const survey = null;

  useEffect(() => {
    if (!bar?.current) {
      setBar({ current: 'DASHBOARD' });
    }
  }, [bar?.current]);

  return (
    <Box
      sx={{
        backgroundColor: BaseColors.background.secondary,
        color: BaseColors.font.primary,
        height: 'calc(100vh - 41px)',
        display: 'flex',
      }}
    >
      {isLoading ? (
        <DashboardSkeleton />
      ) : (
        <>
          <Box
            flex={1}
            height="100%"
            p={2}
            sx={{
              overflowY: 'scroll',
              scrollBehavior: 'smooth',
            }}
          >
            {survey ? (
              <Box>
                <CompleteOnboardingCard flow={survey} />
              </Box>
            ) : (
              <Dashboard />
            )}
          </Box>
          <ContextBarContainer registry={registry} />
        </>
      )}
    </Box>
  );
};

export default DashboardLayout;
